/* eslint-disable arrow-body-style */
import { ICOSConfig, MetricsItemType, RecentViewItemType } from '@/pages/dashboard/types/dashboard';
import dashboardRequest from '../utils/dashboardRequest';
import http from '@/utils/http';

// 获取游戏列表
export const getGameListList: () => Promise<any> = () => {
  return dashboardRequest({
    url: '/api/v1/dashboard/userMessage',
    method: 'post',
    data: {
      style_version: 'v2'
    }
  });
};

// 获取菜单列表
export const getLeftMenuList: (data: any) => Promise<any> = (data) => {
  return http({
    url: '/api/v2/dashboard/menu/listMenu',
    method: 'post',
    data
  }).then(data => {
    return data;
  }, () => {
    return {};
  });
};

// 获取tableau ticker
export const getTicket: (data: any) => Promise<any> = (data) => {
  return dashboardRequest({
    url: '/api/v1/dashboard/getTicket',
    method: 'post',
    data
  });
};

// 获取pdf cos
export const getPdfCos: (data: any) => Promise<any> = (data) => {
  return dashboardRequest({
    url: '/api/v1/dashboard/cos/presigned_url',
    method: 'post',
    data
  });
};

// 获取looker 报表
export const getLooker: (data: any) => Promise<any> = (data) => {
  return dashboardRequest({
    url: '/api/v1/dashboard/looker/signed_url',
    method: 'post',
    data
  });
};

// 获取Looker embed session
export const getLookerEmbedSession: (data: any) => Promise<any> = (data) => http({
  url: '/api/v1/dashboard/looker/get_embed_session',
  method: 'post',
  data
});

// 获取preset信息
export const getPresetInfo: (data: string) => Promise<any> = (data) => {
  return dashboardRequest({
    url: `/api/v1/permission/preset/guest_token/dashboard/${data}`,
    method: 'get',
  });
};

// 获取power bi信息
export const getPowerBIInfo: (reportId: string) => Promise<any> = (reportId) => {
  return dashboardRequest({
    url: `/api/v1/permission/embed/powerbi/${reportId}`,
    method: 'get',
  });
};

// 获取筛选器配置信息
export const loadFilterSelectorList: (data: any) => Promise<any> = (data) => {
  const options = {
    url: '/api/v1/dashboard/selector/visible',
    method: 'post',
    data,
  };
  return dashboardRequest(options);
};

// 获取筛选器列表信息
export const loadFilterList: (data: any) => Promise<any> = (data) => {
  const options = {
    url: '/api/v1/dashboard/selector',
    method: 'post',
    data,
  };
  return dashboardRequest(options);
};

// 获取时区
export const getTimeZone: (data: any) => Promise<any> = (data) => {
  const options = {
    url: '/api/v1/dashboard/timeZone',
    method: 'post',
    data,
  };
  return dashboardRequest(options);
};

// 获取筛选器信息
export const getUaSelect: (data: any) => Promise<any> = (data) => {
  const options = {
    url: '/api/v1/dashboard/ua/selector',
    method: 'post',
    data,
  };
  return dashboardRequest(options);
};

// 操作日志API
export const operationLog: (data: any, opt:any) => Promise<any> = (data, opt={}) => {
  opt = Object.assign(opt, {
    url: `/api/v1/permission/operationLog`,
    method: 'post',
    data,
  });
  return dashboardRequest(opt);
};

// 获取搜索指标信息
export const getMetricsList: (language: string) => Promise<MetricsItemType[]> = (language) => {
  return dashboardRequest({
    url: `/api/v1/permission/rainbow`,
    method: 'post',
    data: {
      key: '',
      group: `dashboard.pc.searchinfo${language}` // group参数就是七彩石中配置的文件名称
    },
    formatData: (data: any) => {
      const { rows = [] } = data || {};
      return rows;
    }
  }) as Promise<MetricsItemType[]>;
};

// 获取搜索特性报表指标信息
export const getCustomizedMetricsList: (gameCode: string) => Promise<MetricsItemType[]> = (gameCode) => {
  return dashboardRequest({
    url: `/api/v1/permission/rainbow`,
    method: 'post',
    data: {
      "key": "",
      "group": `dashboard.pc.${gameCode}_customized_metrics` // group参数就是七彩石中配置的文件名称
    },
    formatData: (data: any) => {
      const { rows = [] } = data || {};
      return rows;
    }
  }) as Promise<MetricsItemType[]>;
};

// 获取最近查看的游戏
export const getRecentViewd: () => Promise<RecentViewItemType[]> = () => {
  return dashboardRequest({
    url: `/api/v1/dashboard/navigation_recent_view`,
    method: 'post',
    data: {
      "style_version": "v2"
    }
  }) as Promise<RecentViewItemType[]>;
};

// #region 收藏相关接口
// 获取收藏的游戏列表
export const getFollowViewd: (payload: any) => Promise<RecentViewItemType[]> = (payload) => {
  return dashboardRequest({
    url: `/api/v1/dashboard/game_following/list`,
    method: 'post',
    data: payload
  }) as Promise<RecentViewItemType[]>;
};

// 添加收藏
export const addFollowGame: (payload: any) => Promise<RecentViewItemType[]> = (payload) => {
  return dashboardRequest({
    url: `/api/v1/dashboard/game_following/add`,
    method: 'post',
    data: payload
  }) as Promise<RecentViewItemType[]>;
};

// 批量添加收藏
export const addFollowBatchGame: (payload: any) => Promise<RecentViewItemType[]> = (payload) => {
  return dashboardRequest({
    url: `/api/v1/dashboard/game_following/save`,
    method: 'post',
    data: payload
  }) as Promise<RecentViewItemType[]>;
};

// 添加收藏
export const removeFollowGame: (payload: any) => Promise<RecentViewItemType[]> = (payload) => {
  return dashboardRequest({
    url: `/api/v1/dashboard/game_following/delete`,
    method: 'post',
    data: payload
  }) as Promise<RecentViewItemType[]>;
};

// 获取所有页面顶部的提示信息
export const getMarqueeInfos: (data: any) => Promise<any> = (data) => {
  return dashboardRequest({
    url: '/api/v1/dashboard/notice',
    method: 'post',
    data,
    noAuth: true
  });
};

// 用户点击了New标记的目录, 上报接口
export const addDashboardPath: (data: any) => Promise<any> = (data) => {
  return dashboardRequest({
    url: '/api/v1/dashboard/menu/add_dashboard_path',
    method: 'post',
    data
  });
};

export const getCOSConfig = (): Promise<ICOSConfig> => {
  return http({
    // url: '/api/v1/homepage/pc/tencent_qcloud/auth?from=dashboard',
    url: '/api/v1/dashboard/cos/auth',
    method: 'get',
  }) as Promise<ICOSConfig>;
};

// 获取所有页面顶部的提示信息
export const getPageConfig: (data: any) => Promise<any> = (data) => {
  return dashboardRequest({
    url: '/api/v1/dashboard/get_page_config',
    method: 'post',
    data
  });
};

// 舆情权限
export const getOpinionPermissions: (data: any) => Promise<any> = (data) => {
  const options = {
    url: '/api/v1/opinion_pc/game/permissions',
    method: 'post',
    data,
  };
  return dashboardRequest(options);
};

// 获取指标注释
export const getExplainInfo: (gameCode:string) => Promise<any> = (gameCode) => {
  return dashboardRequest({
    url: '/api/v1/dashboard/rainbow',
    method: 'post',
    data: {
      game_code: gameCode
    },
    formatData: (data: any) => {
      const { rows = [] } = data || {};
      return rows;
    }
  }) as Promise<any>;
};

// 获取七彩石配置
export const getConfigInfo: (prefixPath:string, path:string) => Promise<any[]> = (prefixPath, path) => {
  return dashboardRequest({
    url: `/api/v1/permission/rainbow`,
    method: 'post',
    data: {
      "key": "",
      "group": `${prefixPath}.${path}`
    }
  }) as Promise<any[]>;
};
/**
 * 获取“经分七彩石”Dashboard信息
 * 
 * @param gameCode - 游戏代号，用于标识具体游戏
 * @param folder - 七彩石 Dashboard 一级目录下的某个子目录。
 * 
 * **目录规则说明：**
 * - 该目录的最后一级必须为以下之一：
 *   - `pc`
 *   - `mobile`
 *   - `base`
 *   - 或某个具体的 `gameCode`
 * - 后端将基于 `gameCode`、框架类型（如 `pc`/`mobile`）、以及 `base` 信息，
 *   自动合并相应的数据并返回给前端。
 * 
 * @returns Promise<MetricsItemType[]> - 返回七彩石指标信息列表（formatData 已剥离 rows 字段）。
 */
export const getDashboardRainbowInfo: (gameCode: string, folder: string, flag?: string) => Promise<MetricsItemType[]> = (
  gameCode,
  folder,
  flag,
) => {
  const data: Record<string, string> = {
    game_code: gameCode,
    folder,
  };
  if (flag) {
    data.flag = flag;
  }
  return dashboardRequest({
    url: '/api/v1/dashboard/rainbow/info',
    method: 'post',
    data,
    formatData: (data: { rows: MetricsItemType[]; }) => {
      const { rows = [] } = data || {};
      return rows;
    },
  }) as Promise<MetricsItemType[]>;
};
// 获取指标注释
export const getAiSummary: (params:{game_code: string; dataKey: string; tag: string; }) => Promise<any> = (params) => {
  return dashboardRequest({
    url: '/api/v1/dashboard/ai',
    method: 'post',
    data: {
      game_code: params.game_code,
      data_key: params.dataKey,
      tag: params.tag
    },
    formatData: (data: any) => {
      const { content } = data || {};
      return content;
    }
  }) as Promise<any>;
};

// 获取 auth_path 页面的鉴权 token
export const getAuthToken: (data: {
  res_id: 'dashboard_pc' ;
  game_code: string;
  menu_id: string;
  page_type: string;
  page_value: string;
  studio_code?: string;
}) => Promise<any> = (data) => {
  return dashboardRequest({
    url: '/api/v1/dashboard/auth_path_token',
    method: 'post',
    data,
    rawData: true,
  });
};

// embed token 签发响应
export interface IEmbedTokenResponse {
  jwt: string;
  url: string;
  expiresIn: number;
}

/**
 * 申请嵌入第三方页面的 ES256 JWT。
 * 后端会反查 menu 表，校验 page_type=public_url，并校验当前用户对该 menu 的访问权。
 * 注意：errorHandler:true 让 http 拦截器跳过全局错误 toast，错误由 SecureIframeRender 内部处理。
 */
export const issueEmbedToken = (data: { resourceId: string }): Promise<IEmbedTokenResponse> => {
  return http({
    url: '/api/v1/dashboard/embed/issue_token',
    method: 'post',
    data,
    // @ts-ignore - errorHandler 是 http 拦截器扩展字段
    errorHandler: true,
    rejectRawData: false,
  }) as Promise<IEmbedTokenResponse>;
};
